import { HiverAutomationAxios } from 'h-commons'
import { CreateApiHandler } from '../../../common/helpers/thunkMiddleware';

export const FETCH_TEMPLATE_LIBRARY_DATA = 'FETCH_TEMPLATE_LIBRARY_DATA';
import { HiverAutomationsAuth } from "../../../common";

const FakeData = [
  {
    "group_id": '1',
    "group_label": "Organise Smarter",
    "rules": [
      {
        "id": 1,
        "label": "Add tags based on Conversation sender",
        "required_feature": ["ftr-assign-among-automation"],
        "trigger": "new_conversation_inbound",
        "conditions": [
          [
            {
              "property": "SUBJECT",
              "op": "contains",
              "values": [
                "Test mail"
              ],
              "options": null,
              "time_slot": {
                "start": null,
                "end": null,
                "timezone": null
              }
            }
          ]
        ],
        "actions": [
          {
            "type": "assign",
          }
        ]
      },
      {
        "id": 2,
        "label": "Add tags based on receipient",
        "required_feature": ["ftr-new-automations-v1"],
        "trigger": "new_conversation_inbound",
        "conditions": [
          [{
            "property": "to",
            "op": "is"
          }]
        ],
        "actions": [
          {
            "type": "add_tag"
          }
        ]
      }
    ]
  },
]

export const fetchTemplateLibraryDataActionCreator = CreateApiHandler(({ isMock, isAutomationsAuthEnabled = false, isHiverApiDomain = true}) => {
  if (isMock) {
    return new Promise((res) => {
      setTimeout(() => {
        res({ data: FakeData })
      }, 3000)
    })
  }

  if(isAutomationsAuthEnabled){
    return new Promise((res, rej) => {
      const automationsNewAuth = async() => {
        try {
          const response = await HiverAutomationsAuth({
            url: `/templates`,
            method: 'GET',
            timeout: 10000,
            isHiverApiDomain,
          });
          res({ data: response.data.templates })
        } catch (err) {
          rej(new Error('Failed to fetch automation template'))
        }
      }
      automationsNewAuth();
    })
  }
  else{
    return new Promise((res, rej) => {
      const hiverAutomationAxiosHandler = async() => {
        try {
          const response = await HiverAutomationAxios({
            url: `/templates`,
            type: 'GET',
            timeout: 10000
          });
          res({ data: response.data.templates })
        } catch (err) {
          rej(new Error('Failed to fetch automation template'))
        }
      }
      hiverAutomationAxiosHandler();
    })
  }
  
}, FETCH_TEMPLATE_LIBRARY_DATA, { showErrorSnackbar: false })